export default __webpack_public_path__ + "static/media/logo_serena_white.98c778e2.svg";